var $ = require('jQuery');
var Vue = require('vue');
var Judging = require('./Judging.vue').default;
const store = require('@/lib/store').default;

var Columnator = require('../../lib/columnator.js');
var OpenRounds = require('../../lib/open-rounds.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function() {
    const judging = new Vue({
        el: '#judging',
        components: {
            'judging': Judging
        },
        store
    });

    $(document).one('pjax:end', () => {
        judging.$destroy();
    });

    new IndexView();
    new Columnator();
    new OpenRounds();
};
